import * as publicTypes from './publicTypes';

const initialState = {
  getClinicProfileById: [],
  clinicProfile: [],
  isLoading: false,
  getDoctProfileById: [],
  doctprofile: [],
  getClinics: [],
};

export default (state = initialState, { type, ...payload }) => {
  switch (type) {



    //POST CLINIC PROFILE 
    case publicTypes.POST_CLINICPROFILE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case publicTypes.POST_CLINICPROFILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        clinicProfile: [...state.clinicProfile, payload.data],
      }
    case publicTypes.POST_CLINICPROFILE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }


    //GET CLINIC PROFILE BY ID
    case publicTypes.GET_CLINICPROFILE_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        getClinicProfileById: payload,
      }
    case publicTypes.GET_CLINICPROFILE_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }
    //POST DOCTOR PROFILE 
    case publicTypes.POST_DOCTORPROFILE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case publicTypes.POST_DOCTORPROFILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        doctprofile: [...state.doctprofile, payload.data],
      }
    case publicTypes.POST_DOCTORPROFILE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }

    //GET DOCTOR PROFILE BY ID
    case publicTypes.GET_DOCTORPROFILE_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        getDoctProfileById: payload,
      }
    case publicTypes.GET_DOCTORPROFILE_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }

    //GET CLINIC
    case publicTypes.GET_CLINIC_SUCCESS:
      return {
        ...state,
        isLoading: false,
        getClinics: payload.data
      }
    case publicTypes.GET_CLINIC_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error
      }

    default:
      return state;
  }
};